import { useState, useEffect, useRef } from 'react';

import { useLocation } from 'react-router-dom';

import { ROUTES } from '../../../routes';

const CALLS_PATH = ROUTES.calls.$path();

export const useFloatingAnimation = (hasActiveCalls: boolean) => {
  const location = useLocation();
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const previousHasActiveCalls = useRef(false);

  const isCallsPage = location.pathname === CALLS_PATH;

  // Animate only when active calls appear
  useEffect(() => {
    // If we now have active calls but didn't before - animate in
    if (hasActiveCalls && !previousHasActiveCalls.current) {
      setShouldAnimate(false);
      const timer = setTimeout(() => setShouldAnimate(true), 50);
      previousHasActiveCalls.current = true;
      return () => clearTimeout(timer);
    }

    // If we had active calls but don't anymore - hide
    if (!hasActiveCalls && previousHasActiveCalls.current) {
      setShouldAnimate(false);
      previousHasActiveCalls.current = false;
      return;
    }

    // Keep the current state
    if (hasActiveCalls) {
      setShouldAnimate(true);
    }
  }, [hasActiveCalls]);

  return {
    shouldAnimate,
    isCallsPage,
  };
};

export const getAnimationClasses = (shouldAnimate: boolean) => {
  return shouldAnimate ? 'translate-y-0 opacity-100' : '-translate-y-96 opacity-0';
};
